export const EVENTS = [
  { value: 'created', name: 'Создание' },
  { value: 'updated', name: 'Изменение' },
  { value: 'deleted', name: 'Удаление' },
  { value: 'file', name: 'Файл' },
  { value: 'split_from_this', name: 'Дробление партии' },
  { value: 'split_to_this', name: 'Новая раздробленная партия' }
]
